import { gql } from '@apollo/client';

export default gql`
    query getABTestValue($abGroup: String!) {
        getABTestValue(abGroup: $abGroup) {
            value
        }
    }
`;
